import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/Home.vue'
import Success from '../pages/Success.vue'
import Error404 from '../pages/errors/404.vue'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'index',
    component: Home,
    props: true
  },
  {
    path: '/success',
    name: 'success',
    component: Success,
    props: true
  },
  {
    path: '/c/:concessionary',
    name: 'concessionary',
    component: Home,
    props: true
  },
  {
    path: '*',
    name: '404',
    component: Error404
  }
]

const router = new VueRouter({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

export default router
